//   import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from "./Home"
import ShowPage from './shows/ShowPage'; 
import GalleryPage from './gallery/Gallery';
import CountdownPage from './CountdownPage';
import Epk from './epk/Epk';
  
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CountdownPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/shows" element={<ShowPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/epk" element={<Epk />} />

        {/* Other routes in your application */}
      </Routes>
    </Router>
  );
}

export default App;